import React, { useState } from 'react';
import { useI18next, useTranslation } from '../../plugins/i18next/ea-react-i18next';
import image from '../../assets/images/easylife365/newsletter/newsletter-logo.svg';
import { HUBSPOT_FORMS } from '../../utils/core';

const NewsletterBanner = () => {
    const { t } = useTranslation("", { keyPrefix: 'app' });
    const [isOpenModal, setIsOpenModal] = useState(false);
    const { i18n } = useI18next();
    const currentLanguage = i18n.language;

    React.useEffect(() => {
        const initializeHubspotForm = () => {

            const formConfig = HUBSPOT_FORMS[currentLanguage];
            if (!formConfig) return;
            
            if ('hbspt' in window) {
                (window as any).hbspt.forms.create(formConfig);
                const elementId = document.getElementById(formConfig.target);
                document.addEventListener("scroll", () => {
                    if (window.scrollY > 170) {
                        elementId?.classList.add("is-sticky");
                    } else {
                        elementId?.classList.remove("is-sticky");
                    }
                });
            } else {
                setTimeout(initializeHubspotForm, 500)
            }
        }

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
        initializeHubspotForm();
    }, []);

    return (
        <>
            <div className='newsletter-container d-print-none' id="newsletter-container">
                <a className="newsletter" onClick={e => { e.preventDefault(); setIsOpenModal(true); }}>
                    <div id="newsletter" className="container-fluid">
                        <div className='n-content'>
                            <div className='left-side'>
                                <a href='javascipt:void(0)' onClick={e => { e.preventDefault(); setIsOpenModal(true); }}>
                                    <img src={image} alt={t('newsletterBanner.logoAlt')} />
                                </a>
                                <div className='n-text'>
                                    <strong>{t('newsletterBanner.strongText')}</strong>
                                    <span className='d-none d-md-block'>{t('newsletterBanner.briefingTextDesktop')}</span>
                                    <span className='d-block d-md-none'>{t('newsletterBanner.briefingTextMobile')}</span>
                                </div>
                            </div>
                            <div className='open-button'>
                                <button type='button' title={t('newsletterBanner.subscribeButton')} className='newsletter-btn'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M6.24992 4.5C5.28344 4.5 4.49996 5.2835 4.49996 6.25V17.75C4.49996 18.7165 5.28344 19.5 6.24992 19.5H17.7496C18.7161 19.5 19.4996 18.7165 19.4996 17.75V13.75C19.4996 13.3358 19.8354 13 20.2496 13C20.6638 13 20.9995 13.3358 20.9995 13.75V17.75C20.9995 19.5449 19.5445 21 17.7496 21H6.24992C4.45504 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45504 3 6.24992 3H10.2498C10.664 3 10.9998 3.33579 10.9998 3.75C10.9998 4.16421 10.664 4.5 10.2498 4.5H6.24992ZM12.9998 3.75C12.9998 3.33579 13.3355 3 13.7497 3H20.25C20.6642 3 21 3.33579 21 3.75V10.25C21 10.6642 20.6642 11 20.25 11C19.8358 11 19.5 10.6642 19.5 10.25V5.56074L14.28 10.7804C13.9871 11.0732 13.5123 11.0732 13.2194 10.7803C12.9265 10.4874 12.9265 10.0125 13.2194 9.71964L18.4395 4.5H13.7497C13.3355 4.5 12.9998 4.16421 12.9998 3.75Z" fill="#242424" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div className={`modal fade ${isOpenModal ? "show" : ""}`} style={{ display: isOpenModal ? "block" : "none" }}>
                <div className="modal-background"></div>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('newsletterBanner.modalTitle')}</h5>
                            <button type="button" className="close" aria-label={t('newsletterBanner.modalCloseButton')} onClick={e => { e.preventDefault(); setIsOpenModal(false); }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div id="formContainer" className='hubspot-form'></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewsletterBanner;
